<script>
    import { LIST_ITEM_SIZE } from '../constants';
	import { currentIndex, images, setCurrentIndex } from '../store';
	let list = [];

	images.subscribe(value => {
	  console.log()
	  list = value
	});
</script>

<ul>
    {#each list as image, index}
        <li
            on:click={() => setCurrentIndex(index)}
            class:active={$currentIndex === index}
            ><img src={image.small} width={LIST_ITEM_SIZE} height={LIST_ITEM_SIZE} alt="" /></li>
    {/each}
</ul>

<style>
    ul, li {
        margin: 0; padding: 0;
    }
    li {
        border: 1px solid transparent; list-style-type: none;
        transition: border-color 250ms ease-in-out; cursor: pointer;
    }
    li + li {
        margin-top: 10px;
    }
    .active {
        border-color: #e67376 !important;
    }
    img {
        display: block;
    }
</style>
